<template>

  <div class="driver-summary-top" :style="{height:contentHeight+'px'}">
      <div class="driver-summary-top-left-item">
        <span class="label">创建人</span>
        <span class="val" v-if="model.createByAvatar"><img :src="model.createByAvatar"/></span>
        <span v-else>{{model.createByName}}</span>
      </div>
      <div class="driver-summary-top-left-item">
        <span class="label">创建日期</span>
        <span class="val">{{model.createTime.substring(2)}}</span>
      </div>
      <div class="driver-summary-top-left-item" v-if="model.backType && !model.backFlag">
        <span class="label">回收倒计时</span>
        <span class="val">{{djs}}</span>
      </div>
      <div class="driver-summary-top-left-item">
        <span class="label">累计时长</span>
        <span class="val">{{ljsc}}</span>
      </div>
  </div>
</template>

<script>
  import { httpAction, getAction,getFileAccessHttpUrl ,deleteAction} from '@/api/manage'
  import {initDictOptions, filterDictText} from '@/components/dict/JDictSelectUtil'
  import { returnCallTimeEng ,returnCallTime,formatDate} from '@/utils/util'
  export default {
    name: 'WorkorderInfoTopNew',
    props: {
      dictOptions:{
        type:Object,
        default:{}
      },
      model:{
        type:Object,
        default:{}
      }
    },
  data(){
      return {
        contentHeight:document.documentElement.clientHeight-200,
        returnCallTimeEng:returnCallTimeEng,
        returnCallTime:returnCallTime
        ,statusMap:{
          1:"进行中",
          2:"已结束",
          4:"进行中"
        },
        ljsc:'',
        djs:''
      }
  },methods:{
      customRender(text,dict){
        //字典值替换通用方法
        return filterDictText(this.dictOptions[dict], text);
      },getLjsc(){
        this.ljsc = this.returnCallTime(this.model.createTime,null);
        if(this.model.backType && !this.model.backFlag){

          this.djs = this.returnCallTime(formatDate(Date.now(),"yyyy-MM-dd hh:mm:ss"),this.model.backTime);
          if(this.djs=="0秒"){
            this.reloadInfo();
          }
        }
        let that = this;
        setTimeout(function(){
          that.getLjsc();
        },1000);
      },reloadInfo(){
        this.$emit("load",1);
      }
    }
  }
</script>
<style lang="less" scoped>


  .driver-summary-top{
    background: #fff;
    border-radius: 12px;
    margin-top: 24px;
    padding: 24px;
  }

  .driver-summary-top  .driver-summary-top-left-item{
    flex:1;
    display: flex;
    gap: 8px;
    align-items: center;
    padding-bottom: 24px;
  }
  .driver-summary-top-left-item .label{
    color: rgba(145, 146, 158, 1);
    font-size: 16px;
  }
  .driver-summary-top-left-item .val{
    color:rgba(10, 22, 41, 1);
    font-size: 16px;
  }
  .driver-summary-top-left-item .val img{
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
  .driver-summary-top-left-item img{
    width: 16px;
    height: 16px;
    margin-left: 30px;
  }
  .driver-summary-top-left-item .time{
    font-size: 12px;
    font-weight: 400;
    color: rgba(63, 140, 255, 1);
  }
  .driver-summary-top-btn{
    width: 145px;
    height: 48px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: rgba(63, 140, 255, 1);
  }
  .driver-summary-top-btn img{
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

</style>